import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';

const DateField = (props) => {
    const {
        elStyle,
        options,
        record,
        source,
    } = props;

    if (!record) {
        return null;
    }

    const value = utils.get(record, source);

    if (utils.isEmpty(value)) {
        return null;
    }

    return (
        <span style={ elStyle }>
            { utils.toDateString(
                utils.createDateTime(value), options
            ) }
        </span>
    );
};

DateField.defaultProps = {
    options: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    },
};

DateField.propTypes = {
    elStyle: PropTypes.object,
    options: PropTypes.object,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default DateField;



// WEBPACK FOOTER //
// ./src/components/field/DateFields/DateField.js